export const PROFILE = {
  name: "Jake Miller",
  avatar: "/images/profile-page/avatar.png",
  email: "jakemiller@searchparties.com",
  dob: new Date("11-11-1985"),
  tel: "+447713031784",
};
